module.exports = __webpack_public_path__ + "7988830715c23c9d75b886cea7920356.svg";